// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import Zone from "@insite/client-framework/Components/Zone";
import { GetBillTosApiParameter } from "@insite/client-framework/Services/CustomersService";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getCurrentAccountState } from "@insite/client-framework/Store/Data/Accounts/AccountsSelector";
import loadCurrentAccount from "@insite/client-framework/Store/Data/Accounts/Handlers/LoadCurrentAccount";
import { getBillTosDataView } from "@insite/client-framework/Store/Data/BillTos/BillTosSelectors";
import setInitialValues from "@insite/client-framework/Store/Pages/AccountSettings/Handlers/SetInitialValues";
import PageModule from "@insite/client-framework/Types/PageModule";
import PageProps from "@insite/client-framework/Types/PageProps";
import LoadingSpinner, { LoadingSpinnerProps } from "@insite/mobius/LoadingSpinner";
import Page from "@insite/mobius/Page";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import * as React from "react";
import { connect, ResolveThunks } from "react-redux";

// XNG-Changes
interface OwnProps {
    billTosParameter: GetBillTosApiParameter;
}

const mapStateToProps = (state: ApplicationState, props: OwnProps) => ({
    shouldLoadAccount: !getCurrentAccountState(state).value,
    // XNG-Changes
    billTosDataView: getBillTosDataView(state, props.billTosParameter),
    account: state.pages.accountSettings.editingAccount,
});

const mapDispatchToProps = {
    loadCurrentAccount,
    setInitialValues,
};

type Props = ResolveThunks<typeof mapDispatchToProps> & PageProps & ReturnType<typeof mapStateToProps> & OwnProps;

// XNG-Change
export interface AccountSettingsPageStyles {
    centeringWrapper?: InjectableCss;
    spinner?: LoadingSpinnerProps;
}
export const accountSettingsPageStyles: AccountSettingsPageStyles = {};

const styles = accountSettingsPageStyles;

class AccountSettingsPage extends React.Component<Props> {
    componentDidMount() {
        if (this.props.shouldLoadAccount) {
            this.props.loadCurrentAccount();
        } else {
            this.props.setInitialValues();
        }
    }

    componentDidUpdate(prevProps: Props) {
        if (prevProps.shouldLoadAccount && !this.props.shouldLoadAccount) {
            this.props.setInitialValues();
        }
    }

    render() {
        // XNG-Change
        if (this.props.billTosDataView.isLoading || !this.props.account) {
            return (
                <StyledWrapper {...styles.centeringWrapper}>
                    <LoadingSpinner {...styles.spinner} />
                </StyledWrapper>
            );
        }

        return (
            <Page>
                <Zone contentId={this.props.id} zoneName="Content" />
            </Page>
        );
    }
}

const pageModule: PageModule = {
    component: connect(mapStateToProps, mapDispatchToProps)(AccountSettingsPage),
    definition: {
        hasEditableUrlSegment: true,
        hasEditableTitle: true,
        pageType: "System",
    },
};

export default pageModule;

/**
 * @deprecated Use string literal "AccountSettingsPage" instead of this constant.
 */
export const AccountSettingsPageContext = "AccountSettingsPage";
